// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"baf2e1e6","301":"f17ccb09","335":"046259cd","337":"39fd11c6","366":"ecb0f215","389":"4d948a59","462":"0b19e9f4","539":"f5888cb6","762":"28d27f6a","787":"016a1c64","849":"a926ccbc","928":"5373353d"}[chunkId] + ".chunk.js";
};